import React, { useEffect, useState, useContext } from "react";
import "./SchemeExpenseRatio.css";
import URLstateContext from "../../../provider/CommonContext";
import animation from "../../../images/jm-animation.gif";
import {
  GetMethodData,
  DecryptAESdata,
  GetPostMethodData,
} from "../../../provider/ServiceProvider";
import { trackEvent, trackPageView } from "../../utils/tracking";
function SchemeExpenseRatio() {
  const [SubCategoryName, setSubCategoryName] = useState(
    "Scheme Expense Ratio"
  );
  const { BaseURL, BaseURLShare } = useContext(URLstateContext);
  const [DataMisc, setDataMisc] = useState("");
  const [loadingshow, setLoadingshow] = useState(false);

  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/SIDdisclosures/Scheme-Expense-Ratio",
      "jmf_sid-disclosures_scheme-expense-ratio"
    );
    // trackPageView(
    //   "http://localhost:710/SIDdisclosures/Scheme-Expense-Ratio",
    //   "jmf_sid-disclosures_scheme-expense-ratio"
    // );

    trackEvent({
      category: "Static Page",
      action: "SIDdisclosures SchemeExpenses Ratio Page Loaded",
      label: "jmf_sid-disclosures_scheme-expense-ratio",
      value: 1,
    });
  }, []);

  useEffect(() => {
    setLoadingshow(true);
    GetPostMethodData(BaseURL + "Getmiscellaneous", {
      IVSubCategoryName: "Scheme Expense Ratio",
    })
      .then((data) => {
        setLoadingshow(false);
        if (data.data != null && data.data.length > 0) {
          setDataMisc(DecryptAESdata(data.data));
        }
      })
      .catch((error) => {
        setLoadingshow(false);
        //  console.log(error);
      });
  }, [BaseURL]);
  return (
    <>
      {loadingshow ? (
        <div className="textcentervertex" role="status" aria-live="polite" aria-busy="true">
          <img src={animation} alt="" aria-hidden="true" />
          <div className="model_popup">Please Wait...</div>
        </div>
      ) : (
        <>
          <div className="schm expense product_fund-summary-sc">
            <div className="schm-pnl">
              <div className="schmeexis">
                {DataMisc.length === 0 ? (
                  <p
                    style={{ textAlign: "center" }}
                    className="errormsgComNew"
                    role="alert"
                  >
                    No Data Found !!!
                  </p>
                ) : (
              
                    <h6>
                      Please{" "}
                      <span className="link">
                        <a href="/Scheme-Expense-Ratio" className="visit-btn">
                          {" "}
                          Click Here{" "}
                        </a>
                      </span>
                      to download the Scheme Expense Ratio file{" "}
                    </h6>
                 
                )}
                {/* <h6>Please <a>Click Here</a> to download the Scheme Expense Ratio file </h6> */}
              </div>
            </div>
          </div>  
        </>
      )}
    </>
  );
}

export default SchemeExpenseRatio;
